import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    seller_info_container: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        width: 'auto'
    },
    seller_logo: {
        backgroundColor: theme.palette.secondary.light,
        fontSize: '20px',
        border: `2px solid ${theme.palette.common.white}`,
        color: theme.palette.common.white,
        borderRadius: '50%',
        height: '40px',
        width: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    name:{
        fontWeight: 800
    },
    info_container: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '14px',
        lineHeight: '14px',
        marginLeft: '8px',
        maxWidth: '75%',
        overflow: 'hidden',
        color: (light) => light ? theme.palette.common.white : theme.palette.secondary.light,
    }
}));

export {useStyles}